import { Provider } from '@/helpers/accountsIframe';

export interface UserAccountState {
  studentEmailProvider?: Provider[];
  studentEmailHasAccounts?: boolean;
  emailTokenD?: string;
}

const accountsUser: UserAccountState = {
  studentEmailProvider: undefined,
  studentEmailHasAccounts: undefined,
  emailTokenD: undefined,
};

export default accountsUser;
